import {ResourceParams, resources} from "../../../../models/resource/resources";
import {NewBloggerFormField} from "../types/blogger-card.types";

export const bloggerModalResourceType: ResourceParams = resources['bloggers-modal'];
export const skipUnbindCheckPaths = [ 'record-calendars', 'bloggers' ];
export const bloggerProfilesResourceType: ResourceParams = resources['blogger-profiles'];

export const newBloggerFormFields: Array<NewBloggerFormField> = [
  {
    label: 'Имя блогера',
    fieldName: 'username',
  },
  {
    label: 'Ссылка на профиль',
    fieldName: 'url',
  },
  {
    label: 'Ссылка на аватар',
    fieldName: 'avatarUrl',
  }
]
